<template>
  <div class="container-fluid">
    <div class="col-12 my-col col-xl col-lg-12 col-sm-12 ">
      <center><a id='PANAMERAPRD'/><h3>Costs and usage overview Panamera</h3></center>

      <h4>&nbsp&nbspPANAMERA - PRD</h4>
      &nbsp&nbsp&nbsp&nbsp<b-button size='sm' href="#PANAMERAQA">Panamera QA</b-button>&nbsp
      <b-button size='sm' href="#PANAMERADEV">Panamera DEV</b-button><p/>
      <tls team='Panamera'></tls>
      <newRelic :accountId='1521112'> </newRelic>
      <h4>&nbsp&nbsp<a id='PANAMERAQA'/> PANAMERA - QA</h4>&nbsp&nbsp&nbsp&nbsp<b-button size='sm' href="#PANAMERAPRD">back to top</b-button><p/>
      <newRelic :accountId='1512068'> </newRelic>
      <h4>&nbsp&nbsp<a id='PANAMERADEV'/> PANAMERA - DEV</h4>&nbsp&nbsp&nbsp&nbsp<b-button size='sm' href="#PANAMERAPRD">back to top</b-button><p/>
      <newRelic :accountId='1512067'> </newRelic>
  </div>
</div>  
</template>
<script>

import newRelic from '@/pages/newrelic.vue'
import panameraAkamai from '@/pages/teams/panamera/akamai.vue'
import tls from '@/pages/teams/components/tls.vue'

export default {
  components: {
    newRelic,
    tls,
    panameraAkamai,
  },
}
</script>
